import React from 'react';
import { Wrapper, OuterWrapper, Spinner, Icon } from './elements';

function Loader(props) {
  return (
    <Wrapper className={props.className}>
      <OuterWrapper>
        <Spinner />
        <Icon icon={'icon-photo'} />
      </OuterWrapper>
    </Wrapper>
  );
}

export default Loader;
